import { all } from 'redux-saga/effects'

import { listSaga } from './list/saga'

export function* specificSaga() {
  yield all([listSaga()])
}
